import React, {useEffect, useState} from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
    axios,
} from "../../../cores/axiosWrapper";
import { parseQueryParameter } from "../../../cores";
import { ImageCredentialGet } from "@mzc-cloudplex/icons";
import { CircularProgress, Grid, Stack, Typography } from "@mzc-pdc/ui";
import {useSelector} from "react-redux";

/**
 * Native Application에서 브라우져 연동해서 CPM Access token 받아갈 수 있도록 연동해주는 페이지
 * @param t
 * @param match
 * @param location
 * @param history
 * @returns {Element}
 * @constructor
 */
const AccessTokenBridge = ({ t, match, location, history }) => {
    const [message, setMessage] = useState("Creating access token.");
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const token = useSelector(({ token }) => token);

    useEffect(async () => {
        const queryParams = parseQueryParameter(location.search);
        const id = queryParams.get("id");
        if (id && token?.value) {
            try {
                const response = await axios.put(`https://oscv3lvf99.execute-api.ap-northeast-2.amazonaws.com/prod/access-tokens`, {
                    id,
                    product: "CPM",
                    refreshToken: token.data?.refreshToken,
                    expiresIn: token.data?.expiresIn
                });
                if(response.status === 204) {
                    setMessage("Sucessfully created access token. Please check from the requested client.");
                } else {
                    setMessage("Failed to create access token. Please try again from the requested client.");
                }
                setShowConfirmButton(true);
            } catch(e) {
                console.error(`failed to create access token: ${e}`);
                setMessage("Failed to create access token. Please try again from the requested client.");
                setShowConfirmButton(true);
            }
        }
        else {
            setMessage("Failed to create access token. Please try again from the requested client.");
            setShowConfirmButton(true);
        }
        return () => {

        };
    }, []);
    const onClickConfirm = () => {
        history.replace("/spaces");
    }
    return (<Grid container sx={{height: `100%`}}>
        <Grid container alignItems={'center'} sx={{height: 32, px: 1.5, gap: 0.75}} >
        </Grid>
        <Grid item xs>
            <Stack gap={2.5} alignItems={'center'}>
                <ImageCredentialGet width={76} height={70}/>
                <Typography
                    variant={"body1_500"}>{t(`common::msg::${message}`, message)}</Typography>
                {!showConfirmButton &&
                    (
                        <CircularProgress color={"primary"} size={32}/>
                    )
                }
                {showConfirmButton &&
                    (
                        <button
                            type={"button"}
                            className={"btn btn-primary"}
                            onClick={(e) => {
                                onClickConfirm();
                            }}
                        >
                            {t(`common::label::Go to space list`, "Go to space list")}
                        </button>
                    )
                }
            </Stack>
        </Grid>
    </Grid>);
};

export default withTranslation()(withRouter(AccessTokenBridge));